export default __webpack_public_path__ + "static/media/icon-twitter.f5288fd8.svg";